var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongSanlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5H3a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h3m0-11v11m0-11h4m-4 11h4m0-11h3a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-3m0-11v11",
    stroke: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMi41SDNDMi43MjM4NiAyLjUgMi41IDIuNzIzODYgMi41IDNWMTNDMi41IDEzLjI3NjEgMi43MjM4NiAxMy41IDMgMTMuNUg2TTYgMi41VjEzLjVNNiAyLjVIMTBNNiAxMy41SDEwTTEwIDIuNUgxM0MxMy4yNzYxIDIuNSAxMy41IDIuNzIzODYgMTMuNSAzVjEzQzEzLjUgMTMuMjc2MSAxMy4yNzYxIDEzLjUgMTMgMTMuNUgxME0xMCAyLjVWMTMuNSIgc3Ryb2tlPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongSanlan as ReactComponent };